"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = resetPassword;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
/**
 * Calls the supplied resetPassword endpoint.
 *
 * @param {string} token - The security token of the user to reset password.
 * @param {string} password - The new password supplied by the user
 * @param {string} endpoint - The endpoint to make a request
 * @param {string} authToken - The (anonymous) authentication token for calling printdeal endpoints
 * @param {string} store - The store from the website
 *
 * @returns Axios promise with a success or error
 */
function resetPassword(token, password, endpoint, authToken, store) {
  var data = {
    token: token,
    password: password,
    store: store
  };
  return (0, _axios["default"])({
    url: endpoint,
    method: 'POST',
    headers: {
      Authorization: authToken,
      'Content-type': 'application/json'
    },
    data: data
  });
}